import { render } from "./subpartA12.vue?vue&type=template&id=93f81814&scoped=true"
import script from "./subpartA12.vue?vue&type=script&lang=js"
export * from "./subpartA12.vue?vue&type=script&lang=js"

import "./subpartA12.vue?vue&type=style&index=0&id=93f81814&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f81814"]])

export default __exports__